export default __webpack_public_path__ + "static/media/more_vert.48dc93dd.svg";